import { observer } from 'mobx-react-lite'
import WifiOffIcon from '@mui/icons-material/WifiOff'

export default observer(function AnnouncementOffline() {

   return <>
      <WifiOffIcon sx={{ mr: 1, fontSize: '20px' }} />
      You're currently offline, so any further changes won’t be saved. Please reconnect before continuing.
   </>
})
